import { FiInbox, FiSearch } from "react-icons/fi";
import styles from "./TableEmptyState.module.css";

const ICONS = {
  inbox: FiInbox,
  search: FiSearch,
};

/**
 * Cədvəllər üçün boş vəziyyət / "tapılmadı" komponenti.
 * @param {string} title - Əsas başlıq (məs: "Heç bir tələbə tapılmadı")
 * @param {string} [description] - İstəyə bağlı təsvir
 * @param {React.ReactNode} [action] - İstəyə bağlı əlavə əməliyyat (düymə və s.)
 * @param {string} [icon] - "inbox" | "search" - ikon növü (inbox: boş siyahı, search: axtarışda tapılmadı)
 */
const TableEmptyState = ({ title, description, action, icon = "inbox" }) => {
  const IconComponent = ICONS[icon] || FiInbox;

  return (
    <div className={styles.wrapper} role="status" aria-label={title}>
      <div className={styles.card}>
        <div className={styles.iconWrap}>
          <IconComponent className={styles.icon} aria-hidden />
        </div>
        <h3 className={styles.title}>{title}</h3>
        {description && <p className={styles.description}>{description}</p>}
        {action && <div className={styles.action}>{action}</div>}
      </div>
    </div>
  );
};

export default TableEmptyState;
